export * from "./gatsby-wrap-root-element"
import * as React from "react"

export const shouldUpdateScroll = () => {
    return window.location.hash !== "#keep-position"
}